import script from "./add-standard.vue?vue&type=script&setup=true&lang=js"
export * from "./add-standard.vue?vue&type=script&setup=true&lang=js"

import "./add-standard.vue?vue&type=style&index=0&id=04fbb1c2&lang=scss&scoped=true"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04fbb1c2"]])

export default __exports__